const incidentStatus = (() => {
  let statusTable, statusData;
  function showDeleteConfirmationPopup(message, callback) {
    const popup = POPUP.build({
      classNames: 'setupDeleteConfirmation',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const yesBtn = new Button({
      text: 'Yes',
      style: 'primary',
      styleType: 'contained',
    });
    const noBtn = new Button({
      text: 'No',
      style: 'primary',
      styleType: 'outlined',
    });

    yesBtn.onClick(e => {
      POPUP.hide(popup);
      callback(true);
    });
    noBtn.onClick(e => {
      POPUP.hide(popup);
      callback(false);
    });

    const btnWrapEle = document.createElement('div');
    btnWrapEle.classList.add('btn-wrap');
    yesBtn.renderTo(btnWrapEle);
    noBtn.renderTo(btnWrapEle);

    popup.append(messageEle);
    popup.append(btnWrapEle);

    POPUP.show(popup);
  }
  function showUnableToDeletePopup(message) {
    const popup = POPUP.build({
      classNames: 'unableToDeletePopup',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const okBtn = new Button({
      text: 'Ok',
      style: 'primary',
      styleType: 'contained',
    });
    okBtn.onClick(e => {
      POPUP.hide(popup);
    });

    popup.append(messageEle);
    okBtn.renderTo(popup);
    POPUP.show(popup);
  }
  function checkForRequiredFields(formInstance) {
    const invalidElements = [...formInstance.form.querySelectorAll(`input:invalid,select:invalid`),];
    const allElements = [...formInstance.form.querySelectorAll('input:valid, select:valid')];
    const isFormValid = Array.from(allElements).every(field => field.value && field.value.trim() !== '');

    if (invalidElements.length > 0 || !isFormValid) {
      formInstance.buttons['submit'].toggleDisabled(true);
    } else {
      formInstance.buttons['submit'].toggleDisabled(false);
    }
  }

  function showAlreadyExistsWarning(msg, form) {
    const warningPopup = POPUP.build({ hideX: true });
    warningPopup.classList.add('warning');
    const message = document.createElement('p');
    message.innerHTML = msg;
    message.style.marginBottom = '15px';
    const btnWrap = document.createElement('div');
    btnWrap.classList.add('btnWrap');
    const okBtn = button.build({
      text: 'Ok',
      type: 'contained',
      style: 'secondary',
      callback: () => {
        POPUP.hide(warningPopup);
        const overlay = document.querySelector('.overlay');
        if (overlay) overlay.classList.add('visible');
        form.buttons['cancel'].toggleDisabled(false);
      },
    });
    btnWrap.appendChild(okBtn);
    warningPopup.appendChild(message);
    warningPopup.appendChild(btnWrap);
    POPUP.show(warningPopup);
    const closeBtn = warningPopup.querySelector('.closePopupBtn');
    if (closeBtn) closeBtn.remove();
  }
  // Incident Status
  //-------------------------------------------------------------------------------

  function getIncidentStatusView() {
    const frag = document.createDocumentFragment();
    
    statusTable = table.build({
      tableId: 'accountClassTable',
      columnHeadings: ['Status'],
      endIcon: true,
    });

    const headers = statusTable.querySelectorAll('.header div');
    headers[0].setAttribute('data-type', 'string');

    const addStatusBtnDiv = document.createElement('div');
    const addStatusBtn = new Button({
      text: 'ADD NEW STATUS',
      style: 'primary',
      icon: 'add',
      styleType: 'outlined',
    });

    frag.append(statusTable);
    if ($.session.SetupInsert) {
      addStatusBtn.button.style.float = 'right';
      addStatusBtn.renderTo(addStatusBtnDiv);
      frag.append(addStatusBtnDiv);
    }

    const tableStatusData = statusData
      .map(p => {
        return {
          values: [p.statusName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showStatusPopup(p);
          },
          endIconCallback: () => handleStatusDelete(p),
        };
      });

    table.populate(statusTable, tableStatusData);
    table.sortTableByHeader(statusTable);

    addStatusBtn.onClick(e => {
      showStatusPopup();
    });

    return frag;
  }

  // Incident Status
  //-------------------------------------------------------------------------------

  function showStatusPopup(rowData) {
    const popup = POPUP.build({
      classNames: 'accountClassPopup',
      hideX: true,
    });

    const statusForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Status',
          id: 'cName',
          required: true,
        },
      ],
    });

    statusForm.onKeyup(() => {
      statusForm.inputs['cName'].setValidtyError('');
      statusForm.inputs['cName'].clearErrorOrWarning();
      checkForRequiredFields(statusForm);
    });
    statusForm.onChange(event => {
      statusForm.inputs['cName'].setValidtyError('');
      statusForm.inputs['cName'].clearErrorOrWarning();
      checkForRequiredFields(statusForm);
    });

    statusForm.onSubmit(async formdata => {
      const resp = (
        await _UTIL.fetchData('insertUpdateIncidentStatusData', {
          id: rowData ? rowData.statusId : 0,
          statusName: formdata.cName.trim(),
          userId: $.session.UserId
        })
      ).insertUpdateIncidentStatusDataResult;
      const newID = resp.statusId;
      if (newID == '-1') {
        showAlreadyExistsWarning('This status already exists.', statusForm);
        statusForm.buttons['submit'].toggleDisabled(true);
        statusForm.buttons['cancel'].toggleDisabled(true);
      } else {
        statusForm.clear();
        POPUP.hide(popup);
        await getStatusData();
        updateStatusTable();
      }
    });

    statusForm.onCancel(event => {
      statusForm.clear();
      statusForm.buttons['submit'].toggleDisabled(true);
      POPUP.hide(popup);
    });

    statusForm.renderTo(popup);

    POPUP.show(popup);

    statusForm.populate({
      cName: rowData ? rowData.statusName : '',
    });

    statusForm.buttons['submit'].toggleDisabled(true);

    if (!$.session.SetupUpdate && rowData) {
      statusForm.disableFormInputs();
    }
  }

  async function handleStatusDelete(row) {
    const rowData = statusData.find(a => a.statusId == row.statusId);

    if (rowData.isAccountExistCount == 'Y') {
      showUnableToDeletePopup('This status is used somewhere else in the system. It cannot be deleted.');
    } else {
      showDeleteConfirmationPopup('Are you sure you want to delete this status?', async deleteRecord => {
        if (deleteRecord) {
          await _UTIL.fetchData('deleteIncidentStatusData', {
            token: $.session.Token,
            statusId: row.statusId,
          });

          await getStatusData();
          updateStatusTable();
        }
      });
    }
  }
  function updateStatusTable() {
    const tableStatusData = statusData
      .map(p => {
        return {
          values: [p.statusName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showStatusPopup(p);
          },
          endIconCallback: () => handleStatusDelete(p),
        };
      });

    table.populate(statusTable, tableStatusData);
  }

  async function getStatusData() {
    const dataStatus = await _UTIL.fetchData('getIncidentStatus');
    statusData = dataStatus.getIncidentStatusResult;
  }


  // Main
  //-------------------------------------------------------------------------------
  async function getView(viewName) {
    const viewFragment = document.createDocumentFragment();
    await getStatusData();

    const viewHeading = document.createElement('h1');
    viewHeading.classList.add('viewHeading');
    viewHeading.textContent = 'Status';

    const viewBody = document.createElement('div');
    viewBody.classList.add('viewBody');

    let viewMarkup;

    if (viewName === 'Status') {
      viewMarkup = getIncidentStatusView();
    }

    if (viewMarkup) {
      viewFragment.append(viewHeading);
      viewFragment.append(viewBody);
      viewBody.append(viewMarkup);
    }

    return viewFragment;
  }

  return {
    getView,
  };
})();
